import React, { useState, Children, cloneElement } from 'react';
import classNames from 'classnames';
import Spin from '../Spin';
import CollapsePanel from './Panel';
import NoResult from '../NoResult';
import defaultMotion from './defaultMotion';

function getActiveKey(activeKey) {
  let currentActiveKey = activeKey;
  if (!Array.isArray(currentActiveKey)) {
    return (currentActiveKey = currentActiveKey
      ? [String(currentActiveKey)]
      : []);
  }
  console.log('activeKey', activeKey);
  return currentActiveKey.map(key => String(key));
}
const Collapse = props => {
  const {
    prefixCls = 'hfish-collapse',
    className,
    style,
    onChange = () => {},
    accordion = false,
    destroyInactivePanel: rootDestroyInactivePanel = false,
    collapsible,
    expandIcon,
    children,
    openMotion = defaultMotion,
    defaultActiveKey,
    noDataTip = '暂无数据',
    emptyIcon,
    loading = false,
    delay = 500,
    loadingTip = '',
    ghost
  } = props;

  let currentActiveKey = defaultActiveKey;
  if ('activeKey' in props) {
    currentActiveKey = activeKey;
  }

  const [activeKey, setActiveKey] = useState(getActiveKey(currentActiveKey));
  const collapseClassName = classNames({
    [prefixCls]: true,
    [className]: !!className,
    [`${prefixCls}-ghost`]: ghost
  });

  // click pannel if able
  function onClickItem(key) {
    let newActiveKey = [...activeKey];
    if (accordion) {
      newActiveKey = activeKey[0] === key ? [] : [key];
    } else {
      const index = newActiveKey.indexOf(key);
      const isActive = index > -1;
      if (isActive) {
        newActiveKey.splice(index, 1);
      } else {
        newActiveKey.push(key);
      }
    }
    changeActiveKey(newActiveKey);
  }

  function changeActiveKey(activeKey) {
    if (!('activeKey' in props)) {
      setActiveKey(activeKey);
    }
    onChange(accordion ? activeKey[0] : activeKey);
  }

  // modify children node props
  function getNewChild(child, index) {
    if (!child) {
      return null;
    }
    const key = child.key.slice(2) || String(index);
    const {
      header = '',
      headerClass,
      collapsible: childCollapsible,
      destroyInactivePanel
    } = child.props;
    let isActive = false;
    if (accordion) {
      isActive = activeKey[0] === key;
    } else {
      console.log(activeKey, 'act');
      isActive = activeKey.indexOf(key) > -1;
    }

    const mergeCollapsible = childCollapsible || collapsible;
    const childProps = {
      key,
      panelKey: key,
      header,
      headerClass,
      isActive,
      prefixCls,
      destroyInactivePanel: destroyInactivePanel || rootDestroyInactivePanel,
      openMotion,
      accordion,
      children: child.props.children,
      onItemClick: mergeCollapsible === 'disable' ? null : onClickItem,
      expandIcon,
      collapsible: mergeCollapsible,
      ghost
    };
    if (typeof child.type === 'string') {
      return child;
    }
    return React.cloneElement(child, childProps);
  }

  // get children nodes
  function getItems() {
    const { children } = props;
    const childNodes = Children.toArray(children);
    // no data
    if (childNodes.length === 0) {
      return <NoResult desc={noDataTip} icon={emptyIcon} />;
    }
    return Children.toArray(children).map(getNewChild);
  }
  return (
    <Spin spinning={loading} delay={delay} tip={loadingTip}>
      <div
        className={collapseClassName}
        style={style}
        role={accordion ? 'tablelist' : null}
      >
        {getItems()}
      </div>
    </Spin>
  );
};
Collapse.Panel = CollapsePanel;

export default Collapse;
